import axiosInstance from '../api';
import { buyerOffMarketMatches, mlsListings } from '@prisma/client';

interface OffMarketMatch extends buyerOffMarketMatches {
  propertyData: any;
  ownerInfo: any;
  marketData: any;
  mlsListing?: mlsListings | null;
}

const offMarketPropertiesService = {
  // Get user's off-market matches
  getMatches: async (): Promise<OffMarketMatch[]> => {
    const res = await axiosInstance.get<OffMarketMatch[]>(
      '/off-market-properties'
    );
    return res.data;
  },

  // Get a specific match
  getMatch: async (id: string): Promise<OffMarketMatch> => {
    const res = await axiosInstance.get<OffMarketMatch>(
      `/off-market-properties/${id}`
    );
    return res.data;
  },

  // Update match status (viewed, contacted, dismissed)
  updateMatch: async (
    id: string,
    updates: {
      isViewed?: boolean;
      isContacted?: boolean;
      isDismissed?: boolean;
    }
  ): Promise<OffMarketMatch> => {
    const res = await axiosInstance.patch<OffMarketMatch>(
      `/off-market-properties/${id}`,
      updates
    );
    return res.data;
  },

  // Mark as viewed
  markViewed: async (id: string): Promise<OffMarketMatch> => {
    return offMarketPropertiesService.updateMatch(id, { isViewed: true });
  },

  // Mark as contacted
  markContacted: async (id: string): Promise<OffMarketMatch> => {
    return offMarketPropertiesService.updateMatch(id, { isContacted: true });
  },

  // Dismiss a match
  dismissMatch: async (id: string): Promise<OffMarketMatch> => {
    return offMarketPropertiesService.updateMatch(id, { isDismissed: true });
  },

  // Delete (dismiss) a match
  delete: async (id: string): Promise<OffMarketMatch> => {
    const res = await axiosInstance.delete<OffMarketMatch>(
      `/off-market-properties/${id}`
    );
    return res.data;
  },

  // Express interest in a property
  expressInterest: async (id: string): Promise<OffMarketMatch> => {
    const res = await axiosInstance.post<OffMarketMatch>(
      `/off-market-properties/${id}/express-interest`,
      {}
    );
    return res.data;
  },
};

export default offMarketPropertiesService;
export type { OffMarketMatch };
